module.exports = __webpack_public_path__ + "img/draw-gh.dc7db2f9.png";